<template>
  <div class="authentication_form_box">
    <div class="scholar_top">
      <van-icon
        style="position: absolute; left: 10px"
        size="25"
        name="arrow-left"
        @click="to()"
      />
      <div class="my">基本信息</div>
      <div class="determine" @click="setSave">
        {{ status == 0 ? "审核中" : "保存" }}
      </div>
    </div>
    <div class="scholar_bottom">
      <!-- 回显不通过原因 -->
      <van-cell-group class="cell_group_box" v-if="status == 2 && cause">
        <van-cell
          class="scholar_text"
          :title="cause"
          is-link
          :to="{
            path: 'noPass',
            query: { cause },
          }"
        />
      </van-cell-group>
      <p class="group_title">基本信息</p>
      <van-cell-group class="cell_group_box">
        <van-cell class="upload_box" :required="true" title="头像" center>
          <template>
            <van-image
              class="upload_img"
              round
              width="37px"
              height="37px"
              :src="
                periodical.periodicalLogo
                  ? $global.imgUrl + periodical.periodicalLogo
                  : require('@/assets/img/mobile-img/upload-default.png')
              "
              @click="preview(periodical.periodicalLogo)"
            />
            <van-uploader
              :disabled="status == 0"
              :max-size="1 * 1024 * 1024"
              :before-read="beforeRead"
              :after-read="(file) => clzpAfterRead(file, 'periodicalLogo')"
              @oversize="onOversize"
            >
              <van-icon class="upload_icon" name="arrow" />
            </van-uploader>
          </template>
        </van-cell>
        <van-cell
          :required="true"
          title="期刊名称"
          :value="periodical.name | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'name',
              label: '期刊名称',
              ruleKey: 'name',
              disabled: true,
            })
          "
          is-link
        />
        <van-cell class="upload_box" :required="true" title="封面" center>
          <van-image
            class="upload_img upload_img_card"
            width="42px"
            height="60px"
            :src="
              periodical.coverImg
                ? $global.imgUrl + periodical.coverImg
                : require('@/assets/img/mobile-img/zz_default.png')
            "
            @click="preview(periodical.coverImg)"
          />
          <van-uploader
            :disabled="status == 0"
            :max-size="1 * 1024 * 1024"
            :before-read="beforeRead"
            :after-read="(file) => clzpAfterRead(file, 'coverImg')"
            @oversize="onOversize"
          >
            <van-icon class="upload_icon" name="arrow" />
          </van-uploader>
        </van-cell>
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell class="list_cell" :required="true" title="主管单位" center>
          <template>
            <div class="list_btn" @click="toAddList('responsibleDeptList')">
              添加
            </div>
          </template>
        </van-cell>
        <van-cell
          v-for="(item, index) in periodical.responsibleDeptList"
          :key="index"
          :title="'主管单位' + (index + 1)"
          :value="item.orgName | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'responsibleDeptList.' + index + '.orgName',
              label: '主管单位' + (index + 1),
              ruleKey: 'name',
              hasDeleteBtn: true,
            })
          "
          is-link
        />
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell class="list_cell" :required="true" title="主办单位" center>
          <template>
            <div class="list_btn" @click="toAddList('organizerList')">添加</div>
          </template>
        </van-cell>
        <van-cell
          v-for="(item, index) in periodical.organizerList"
          :key="index"
          :title="'主办单位' + (index + 1)"
          :value="item.orgName | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'organizerList.' + index + '.orgName',
              label: '主办单位' + (index + 1),
              ruleKey: 'name',
              hasDeleteBtn: true,
            })
          "
          is-link
        />
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell class="list_cell" :required="true" title="出版单位" center>
          <template>
            <div class="list_btn" @click="toAddList('publishCompanyList')">
              添加
            </div>
          </template>
        </van-cell>
        <van-cell
          v-for="(item, index) in periodical.publishCompanyList"
          :key="index"
          :title="'出版单位' + (index + 1)"
          :value="item.orgName | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'publishCompanyList.' + index + '.orgName',
              label: '出版单位' + (index + 1),
              ruleKey: 'name',
              hasDeleteBtn: true,
            })
          "
          is-link
        />
      </van-cell-group>
      <van-cell-group class="cell_group_box">
        <van-cell
          :required="true"
          title="出版周期"
          :value="publishPeriodText | isNull"
          @click="openPopup('periodPickerShow')"
          is-link
        />
        <van-popup
          v-model="periodPickerShow"
          position="bottom"
          round
          @opened="publishPopupOpen"
        >
          <van-picker
            ref="publishPickerRef"
            show-toolbar
            :columns="periodPickerColumns"
            value-key="label"
            @confirm="periodPickerConfirm"
            @cancel="periodPickerShow = false"
          />
        </van-popup>
        <van-cell
          :required="true"
          title="CN"
          :value="periodical.cn | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'cn',
              label: 'CN',
              ruleKey: 'CN',
            })
          "
          is-link
        />
        <van-cell
          :required="true"
          title="ISSN"
          :value="periodical.issn | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'issn',
              label: 'ISSN',
              ruleKey: 'CN',
            })
          "
          is-link
        />
        <van-cell
          :required="true"
          title="期刊分类"
          :value="periodical.subject | isNull"
          @click="openPopup('subjectPickerShow')"
          is-link
        />
        <van-popup
          v-model="subjectPickerShow"
          position="bottom"
          round
          @opened="subjectPopupOpen"
        >
          <van-picker
            ref="subjectPickerRef"
            show-toolbar
            :columns="[{ values: qkOptions }, { values: qkSecondOptions }]"
            value-key="label"
            title="请选择期刊分类"
            :loading="subjectLoading"
            @cancel="subjectPickerShow = false"
            @change="subjectPickerChange"
            @confirm="subjectPickerConfirm"
          />
        </van-popup>
        <van-cell
          title="邮发代号"
          :value="periodical.codeDomestic | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'codeDomestic',
              label: '邮发代号',
              ruleKey: 'codeDomestic',
            })
          "
          is-link
        />
        <van-cell
          title="创刊时间"
          :value="periodical.foundedDate | isNull"
          @click="openPopup('datePickerShow')"
          is-link
        />
        <van-popup
          v-model="datePickerShow"
          position="bottom"
          round
          @opened="datePopupOpen"
        >
          <van-picker
            ref="datePickerRef"
            show-toolbar
            :columns="datePickerColumns"
            @cancel="datePickerShow = false"
            @confirm="datePickerConfirm"
          />
        </van-popup>
        <van-cell
          title="出版地"
          :value="
            `${periodical.publishAddrProvince}-${periodical.publishAddrCity}`
              | isNull
          "
          @click="openPopup('addrPickerShow')"
          is-link
        />
        <van-popup
          v-model="addrPickerShow"
          position="bottom"
          round
          @opened="addrPopupOpen"
        >
          <van-picker
            ref="addrPickerRef"
            show-toolbar
            :columns="[{ values: provinceOptions }, { values: cityOptions }]"
            value-key="label"
            title="请选择出版地"
            :loading="addrLoading"
            @cancel="addrPickerShow = false"
            @change="addrPickerChange"
            @confirm="addrPickerConfirm"
          />
        </van-popup>
        <van-cell
          title="语种"
          :value="languagePeriodText | isNull"
          @click="openPopup('languagePickerShow')"
          is-link
        />
        <van-popup
          v-model="languagePickerShow"
          position="bottom"
          round
          @opened="languagePopupOpen"
        >
          <van-picker
            ref="languagePickerRef"
            show-toolbar
            :columns="languagePickerColumns"
            value-key="label"
            @cancel="languagePickerShow = false"
            @confirm="languagePickerConfirm"
          />
        </van-popup>
        <van-cell
          title="开本"
          :value="periodical.format | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'format',
              label: '开本',
              ruleKey: 'length20',
            })
          "
          is-link
        />
        <van-cell
          title="E-mail"
          :value="periodical.email | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'email',
              label: 'E-mail',
              ruleKey: 'email',
            })
          "
          is-link
        />
        <van-cell
          title="投稿地址"
          :value="periodical.contributeAddr | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'contributeAddr',
              label: '投稿地址',
              ruleKey: 'website',
            })
          "
          is-link
        />
        <van-cell
          title="官网地址"
          :value="periodical.officialWebsiteAddr | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'officialWebsiteAddr',
              label: '官网地址',
              ruleKey: 'website',
            })
          "
          is-link
        />
        <van-cell
          title="收录数据库"
          :value="periodical.coreName | isNull"
          @click="openPopup('corePopupShow')"
          is-link
        />
        <van-action-sheet
          v-model="corePopupShow"
          title="收录数据库"
          @open="corePopupOpen"
        >
          <div class="core-popup-box">
            <van-checkbox-group v-model="coreArr">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in coreList"
                  clickable
                  :key="item"
                  :title="item"
                  @click="coreToggle(index)"
                >
                  <template #right-icon>
                    <van-checkbox :name="item" ref="coreCheckboxes" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
            <van-button
              class="core-popup-btn"
              round
              type="info"
              @click="confirmCore"
              >确定</van-button
            >
          </div>
        </van-action-sheet>
        <van-cell
          title="简介"
          :value="periodical.signature | isNull"
          @click="
            toEdit('InputEdit', {
              objName: 'periodical',
              key: 'signature',
              label: '简介',
              type: 'textarea',
              ruleKey: 'length100',
            })
          "
          is-link
        />
      </van-cell-group>
      <van-cell-group class="record_box cell_group_box">
        <div class="record_item">
          <van-cell
            :value="periodicalIntro.value | isEditNull"
            is-link
            @click="
              toPeriodicalEdit(
                periodicalIntro.status,
                '期刊简介',
                'periodicalIntro'
              )
            "
          >
            <template #title>
              <span>期刊简介</span>
              <span
                :class="['record_tag', recordTag(periodicalIntro.status)]"
                >{{ periodicalIntro.status | tagType }}</span
              >
            </template>
          </van-cell>
          <div
            class="record_reason"
            v-if="periodicalIntro.status == 2 && periodicalIntro.cause"
          >
            {{ periodicalIntro.cause }}
          </div>
        </div>
        <div class="record_item">
          <van-cell
            :value="notice.value | isEditNull"
            is-link
            @click="toPeriodicalEdit(notice.status, '征稿启事', 'notice')"
          >
            <template #title>
              <span>征稿启事</span>
              <span :class="['record_tag', recordTag(notice.status)]">{{
                notice.status | tagType
              }}</span>
            </template>
          </van-cell>
          <div class="record_reason" v-if="notice.status == 2 && notice.cause">
            {{ notice.cause }}
          </div>
        </div>
      </van-cell-group>
    </div>
    <TipsDialog
      :showDialog="changeModalShow"
      @dialogCancel="leavePage"
      @dialogConfirm="setSave"
      @clickOverlay="changeModalShow = false"
    >
      是否保存本次修改？
    </TipsDialog>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
export default {
  name: "PeriodicalModification",
  components: {
    TipsDialog,
  },
  data() {
    return {
      periodical: {
        periodicalLogo: null,
        name: null,
        coverImg: null,
        responsibleDeptList: [],
        organizerList: [],
        publishCompanyList: [],
        publishPeriod: null,
        cn: null,
        issn: null,
        subject: null,
        subjectId: null,
        codeDomestic: null,
        foundedDate: null,
        publishAddrProvince: null,
        publishAddrCity: null,
        languageType: null,
        format: null,
        email: null,
        coreName: null,
        contributeAddr: null,
        officialWebsiteAddr: null,
        signature: null,
      },
      periodicalIntro: {
        status: 1,
        cause: "",
        value: "",
      },
      notice: {
        status: 1,
        cause: "",
        value: "",
      },
      publishPeriodText: "",
      periodPickerShow: false,
      periodPickerColumns: [
        { label: "年刊", value: 1 },
        { label: "半年刊", value: 2 },
        { label: "季刊", value: 3 },
        { label: "双月刊", value: 4 },
        { label: "月刊", value: 5 },
        { label: "半月刊", value: 6 },
        { label: "旬刊", value: 7 },
        { label: "周刊", value: 8 },
        { label: "周二刊", value: 9 },
      ],
      subjectPickerShow: false,
      subjectLoading: false,
      qkOptions: [],
      qkSecondOptions: [],
      datePickerShow: false,
      datePickerColumns: [],
      addrLoading: false,
      addrPickerShow: false,
      provinceOptions: [],
      cityOptions: [],
      languagePickerShow: false,
      languagePickerColumns: [
        { label: "中文", value: 1 },
        { label: "英文", value: 2 },
        { label: "其他", value: 3 },
      ],
      languagePeriodText: "",
      coreList: [],
      corePopupShow: false,
      coreArr: [],
      changeModalShow: false,
      status: 1,
      cause: "",
    };
  },
  created() {
    this.datePickerColumns = this.getYears();
    this.getPeriodicalList();
    this.getAddrOptionsList();
    this.getIncludeList();
  },
  watch: {
    periodical: {
      handler(newV) {
        sessionStorage.setItem("periodical", JSON.stringify(newV));
      },
      deep: true,
    },
  },
  filters: {
    isEditNull(value) {
      return value && value !== "" && value !== "-" ? "已设置" : "未设置";
    },
    isNull(value) {
      return value && value !== "" && value !== "-" ? value : "未设置";
    },
    isImgNull(value) {
      return value !== "" ? "已上传" : "未设置";
    },
    tagType(num) {
      if (num == 0) return `审核中`;
      if (num == 2) return `未通过`;
    },
  },
  methods: {
    toPeriodicalEdit(status, title, key) {
      if (status == 0) {
        Toast("审核中");
      } else {
        this.$router.push({
          path: "/periodical-edit",
          query: { title, key },
        });
      }
    },
    openPopup(keyShow) {
      if (this.status == 0) {
        Toast("审核中");
      } else {
        this[keyShow] = true;
      }
    },
    recordTag(type) {
      if (type == 0) return `is_audit`;
      if (type == 2) return `no_pass`;
    },
    leavePage() {
      sessionStorage.setItem("basePeriodical", JSON.stringify(this.periodical));
      this.$router.go(-1);
    },
    // 获取基本信息
    async getUserDetails() {
      const res = await this.$apis.userServe.getMaDetails();
      this.status = res.data.auth ? res.data.auth.status : 1;
      this.cause = res.data.auth ? res.data.auth.cause : "";
      if (!sessionStorage.getItem("periodical")) {
        if (res.data && res.data.auth && res.data.auth.jsonDataObj) {
          let copyPeriodical = this.$global.deepClone(this.periodical);
          let periodical = res.data.auth.jsonDataObj.periodical;
          for (const key in periodical) {
            copyPeriodical[key] = periodical[key];
          }
          sessionStorage.setItem(
            "basePeriodical",
            JSON.stringify(copyPeriodical)
          );
          sessionStorage.setItem("periodical", JSON.stringify(periodical));
        }
      }
      if (res.data && res.data.intro) {
        this.periodicalIntro = {
          status: res.data.intro.status,
          cause: res.data.intro.cause,
          value: res.data.intro.jsonDataObj.periodicalIntro,
        };
      }
      if (res.data && res.data.notice) {
        this.notice = {
          status: res.data.notice.status,
          cause: res.data.notice.cause,
          value: res.data.notice.jsonDataObj.notice,
        };
      }
      this.formateInfo();
    },
    formateInfo() {
      if (sessionStorage.getItem("periodical")) {
        let periodical = JSON.parse(sessionStorage.getItem("periodical"));
        for (const key in periodical) {
          if (key === "publishPeriod" && periodical[key] !== "") {
            const publishPeriodArr = this.periodPickerColumns.filter(
              (item) => item.value == periodical[key]
            );
            this.publishPeriodText = publishPeriodArr.length
              ? publishPeriodArr[0].label
              : "";
          } else if (key === "languageType" && periodical[key] !== "") {
            const languageArr = this.languagePickerColumns.filter(
              (item) => item.value == periodical[key]
            );
            this.languagePeriodText = languageArr.length
              ? languageArr[0].label
              : "";
          }
          this.periodical[key] = periodical[key];
        }
      }
    },
    to() {
      this.$router.go(-1);
    },
    async setSave() {
      if (this.status == 0) return;
      let basicInfoStrValidate = [
        "periodicalLogo",
        "name",
        "coverImg",
        "publishPeriod",
        "cn",
        "issn",
        "subject",
        "subjectId",
      ].every((item) => this.periodical[item] !== "");
      let basicInfoListValidate = [
        "responsibleDeptList",
        "organizerList",
        "publishCompanyList",
      ].every(
        (item) =>
          this.periodical[item].length > 0 &&
          this.periodical[item].every((i) => i.orgName !== "")
      );
      if (basicInfoStrValidate && basicInfoListValidate) {
        let periodical = JSON.parse(sessionStorage.getItem("basePeriodical"));
        for (const key in this.periodical) {
          if (this.periodical[key] === periodical[key]) {
            // 当用户没有更改信息，但是信息内容为''时改为Null
            periodical[key] = periodical[key] === "" ? null : periodical[key];
          } else {
            periodical[key] = this.periodical[key];
          }
        }
        const { data } = await this.$apis.userServe.setMaInfo({
          periodical: this.periodical,
        });
        if (data.resultCode !== "200") {
          Toast(data.resultDesc);
        } else {
          Toast("保存成功");
          sessionStorage.setItem(
            "basePeriodical",
            JSON.stringify(this.periodical)
          );
          this.$router.go(-1);
        }
      } else {
        Toast("请填写基本信息中必填字段");
      }
    },
    // 预览上传的图片
    preview(url) {
      if (url) {
        ImagePreview({
          images: [this.$global.imgUrl + url],
          closeable: true,
        });
      }
    },
    //校验上传图片大小
    onOversize(file) {
      Toast("文件大小不能超过1MB");
    },
    //校验图片的格式
    beforeRead(file) {
      if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
        Toast("仅支持JPG、JPEG、PNG格式");
        return false;
      }
      return true;
    },
    //照片上传事件方法
    async clzpAfterRead(file, key) {
      // 创建一个空对象实例
      let formData = new FormData();
      // 调用append()方法添加数据
      formData.append("file", file.file);
      const res = await this.$apis.myServe.uploadFileMannual(formData);
      this.periodical[key] = res.data;
    },
    // 去编辑
    toEdit(path, query) {
      if (this.status == 0) {
        Toast("审核中");
      } else {
        this.$router.push({ path, query });
      }
    },
    // 增加单位列表
    toAddList(key) {
      if (this.status == 0) return;
      if (this.periodical[key].length < 5) {
        this.periodical[key].push({ orgName: "" });
      } else {
        Toast("最多能添加5条");
      }
    },
    publishPopupOpen() {
      if (this.periodical.languageType) {
        this.$refs.publishPickerRef.setValues([this.publishPeriodText]);
      }
    },
    periodPickerConfirm({ value, label }) {
      this.periodical.publishPeriod = value;
      this.publishPeriodText = label;
      this.periodPickerShow = false;
    },
    // 获取期刊分类
    async getPeriodicalList() {
      this.subjectLoading = true;
      const { perClaOneList } = await this.$apis.hundredServe.getPerOneList();
      this.qkOptions = perClaOneList.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      let chiefSubjectId = this.periodical.subjectId
        ? this.periodical.subjectId.slice(0, 2)
        : this.qkOptions[0].value;
      this.getPeriodicalSecondList(chiefSubjectId);
      this.subjectLoading = false;
    },
    async getPeriodicalSecondList(parentCode) {
      this.subjectLoading = true;
      const { perClaTwoList } =
        await this.$apis.hundredServe.getListByParentCode({ parentCode });
      this.qkSecondOptions = perClaTwoList.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      this.subjectLoading = false;
    },
    subjectPopupOpen() {
      if (this.periodical.subjectId) {
        this.subjectLoading = true;
        let chiefSubjectId = this.periodical.subjectId.slice(0, 2);
        let firstIndex = this.qkOptions.findIndex(
          (item) => item.value === chiefSubjectId
        );
        let secondIndex = this.qkSecondOptions.findIndex(
          (item) => item.value === this.periodical.subjectId
        );
        this.$refs.subjectPickerRef.setColumnIndex(0, firstIndex);
        this.$refs.subjectPickerRef.setColumnIndex(1, secondIndex);
        this.subjectLoading = false;
      }
    },
    async subjectPickerChange(_, values, index) {
      if (index === 0) {
        this.getPeriodicalSecondList(values[0].value);
      }
    },
    subjectPickerConfirm(values) {
      if (values.every((item) => item !== undefined)) {
        this.periodical.subject = values[1].label;
        this.periodical.subjectId = values[1].value;
        this.subjectPickerShow = false;
      }
    },
    getYears() {
      //获取当前时间
      let nowYears = new Date().getFullYear();
      let arrYear = [];
      for (let i = 0; i <= 100; i++) {
        arrYear.push(nowYears--);
      }
      return arrYear;
    },
    datePopupOpen() {
      if (this.periodical.foundedDate) {
        this.$refs.datePickerRef.setValues([this.periodical.foundedDate]);
      }
    },
    datePickerConfirm(value) {
      this.periodical.foundedDate = value;
      this.datePickerShow = false;
    },
    // 获取出版地
    async getAddrOptionsList() {
      this.addrLoading = true;
      const proVinceRes = await this.$apis.userServe.proList();
      this.provinceOptions = proVinceRes.content.provinceList.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      let provinceCode = this.provinceOptions[0].value;
      if (this.periodical.publishAddrProvince) {
        let chooseProvince = this.provinceOptions.filter(
          (item) => item.label === this.periodical.publishAddrProvince
        );
        provinceCode = chooseProvince[0].value;
      }
      this.getAddrSecondOptionsList(provinceCode);
      this.addrLoading = false;
    },
    async getAddrSecondOptionsList(provinceCode) {
      this.addrLoading = true;
      const cityRes = await this.$apis.userServe.cityList({ provinceCode });
      this.cityOptions = cityRes.content.cityList.map((item) => ({
        label: item.name,
        value: item.code,
      }));
      this.addrLoading = false;
    },
    addrPopupOpen() {
      if (
        this.periodical.publishAddrProvince &&
        this.periodical.publishAddrCity
      ) {
        this.addrLoading = true;
        this.$refs.addrPickerRef.setColumnValue(
          0,
          this.periodical.publishAddrProvince
        );
        this.$refs.addrPickerRef.setColumnValue(
          1,
          this.periodical.publishAddrCity
        );
        this.addrLoading = false;
      }
    },
    async addrPickerChange(_, values, index) {
      if (index === 0) {
        this.getAddrSecondOptionsList(values[0].value);
      }
    },
    addrPickerConfirm(values) {
      if (values.every((item) => item !== undefined)) {
        this.periodical.publishAddrProvince = values[0].label;
        this.periodical.publishAddrCity = values[1].label;
        this.addrPickerShow = false;
      }
    },
    languagePopupOpen() {
      if (this.periodical.languageType) {
        this.$refs.languagePickerRef.setValues([this.languagePeriodText]);
      }
    },
    languagePickerConfirm({ value, label }) {
      this.periodical.languageType = value;
      this.languagePeriodText = label;
      this.languagePickerShow = false;
    },
    async getIncludeList() {
      const res = await this.$apis.searchServe.getIncludeList();
      this.coreList = res.dbList.map((item) => item.dbName);
    },
    coreToggle(index) {
      this.$refs.coreCheckboxes[index].toggle();
    },
    corePopupOpen() {
      if (this.periodical.coreName !== "") {
        this.coreArr = this.periodical.coreName.split(",");
      }
    },
    confirmCore() {
      this.periodical.coreName = this.coreArr.join();
      this.corePopupShow = false;
    },
  },
  activated() {
    this.getUserDetails();
  },
  beforeRouteLeave(to, from, next) {
    let basePeriodical = JSON.parse(sessionStorage.getItem("basePeriodical"));
    let noChange = this.$global.equals(basePeriodical, this.periodical);
    if (
      to.name === "InputEdit" ||
      to.name === "periodicalEdit" ||
      to.name === "NoPass"
    ) {
      next();
    } else if (noChange) {
      sessionStorage.removeItem("basePeriodical");
      sessionStorage.removeItem("periodical");
      next();
    } else {
      this.changeModalShow = true;
      next(false);
    }
  },
};
</script>

<style lang="scss" scoped>
.authentication_form_box {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .scholar_top {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    line-height: 44px;
    background: #fff;

    .my {
      font-size: 18px;
      color: #333333;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .scholar_bottom {
    margin: 22px auto;
    padding-bottom: 20px;
    width: 94%;
    height: 100%;

    .group_title {
      margin: 22px 0 12px;
      font-size: 14px;
      color: #999999;
      line-height: 20px;
    }

    .cell_group_box {
      margin-top: 12px;
      border-radius: 8px;
      overflow: hidden;

      .scholar_text {
        width: 100%;
        height: 48px;
        line-height: 28px;
        background: #fff;
        &::v-deep .van-cell__title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .upload_box {
        .upload_img {
          margin-right: 10px;
          vertical-align: middle;
        }

        .upload_img_card {
          border-radius: 5px;
          overflow: hidden;
        }

        .upload_icon {
          height: 24px;
          font-size: 16px;
          line-height: 24px;
          color: #969799;
          vertical-align: middle;
        }
      }

      .list_cell {
        .list_btn {
          font-size: 14px;
          color: #4a79f1;
          line-height: 14px;
        }
      }
    }

    .record_box {
      padding: 0 16px;
      .record_item {
        padding-bottom: 17px;
        border-bottom: 1px solid #eeeeee;
        &::v-deep .van-cell {
          padding: 10px 0 0;
          .van-cell__value {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &::after {
            content: none;
          }
          .record_tag {
            display: inline-block;
            margin-left: 5px;
            padding: 0 5px;
            font-size: 11px;
            border-radius: 2px;
          }
          .is_audit {
            background-color: #fea7361a;
            color: #fea736;
          }
          .no_pass {
            background-color: #ff3d3d1a;
            color: #ff3d3d;
          }
        }
        .record_reason {
          margin-top: 12px;
          padding: 0 10px;
          width: 100%;
          height: 32px;
          line-height: 32px;
          border-radius: 5px;
          background-color: #f5f5f5;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 13px;
          color: #ff132f;
        }
      }
    }
  }

  .core-popup-box {
    .core-popup-btn {
      display: block;
      margin: 10px auto;
      width: 80%;
    }
  }
}
</style>
